import { graphql } from '@apollo/client/react/hoc';
import { AlertService, Button, Card } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { BulkResendInvite } from '../../graphql/mutations';

const styles = {
  button__container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
};

class ResendInviteAction extends Component {
  state = {
    invite: this.props.invite,
    resending: false,
  };

  static getDerivedStateFromProps(nextProps) {
    return { invite: nextProps.invite };
  }

  error = (response) => {
    this.setState({ revoking: false });
    const message =
      'Sorry there was an error resending this invite. If this problem persists, please contact a Spoiler Alert Administrator to help you.';
    this.props.onHide(response, message);
  };

  hide = (response) => {
    const errors = response.data?.bulkResendInvite?.errors;
    if (errors && errors.length > 0) {
      throw new Error(errors[0].message);
    }
    this.setState({ revoking: false });
    this.inviteResent();
    this.props.onHide(response);
  };

  inviteResent() {
    const message = 'Your invitation was successfully resent!';
    AlertService.alert({ type: 'success', message: <span>{message}</span> });
  }

  resend = () => {
    const { refetchQueries, mutate } = this.props;
    this.setState({ resending: true });
    mutate({
      variables: { inviteIds: [this.state.invite._id] },
      refetchQueries,
    })
      .then(this.hide)
      .catch(this.error);
  };

  render() {
    return (
      <Card>
        <h3>Resend Invite</h3>
        <p>Are you sure you want to resend this invite?</p>
        <div className={this.props.classes.button__container}>
          <Button type="button" link onClick={this.props.onHide} disabled={this.state.resending}>
            Cancel
          </Button>
          <Button type="button" primary onClick={this.resend} loading={this.state.resending} loadingText="Wait...">
            Resend
          </Button>
        </div>
      </Card>
    );
  }
}

ResendInviteAction.propTypes = {
  classes: PropTypes.object,
  invite: PropTypes.object,
  onHide: PropTypes.func,
  mutate: PropTypes.func,
  refetchQueries: PropTypes.array,
};

ResendInviteAction.defaultProps = {
  onHide: () => {},
};

export default injectSheet(styles)(graphql(BulkResendInvite)(ResendInviteAction));
